export default __webpack_public_path__ + "8c67aa795f530885fdd5d042022aa2e2.svg";